<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <!-- //espaço em branco// -->
            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>
                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Colaboradores</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>
        </div>
        <div id="pnlista">
            <!-- Botão Novo empresa -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-person-plus"></i> Novo colaborador
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pesquisa empresa  -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tabela de colaboradores -->
            <div class="card">
                <div class="card-body">
                    <!-- Tabela de colaboradores com EasyDataTable -->
                    <EasyDataTable :headers="headers" :items="lstcolaboradores" :pagination="false" hide-footer
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id }">
                            <div style="display: flex; justify-content: center;">
                                <a @click="mtdalterar(id)" class="btn btn-sm btn-warning">
                                    <i class="bi bi-pencil-square"></i>
                                </a>
                                <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-danger"
                                    @click="mtdexcluir(id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </template>
                        <template #item-nome="{ tipo, nome }">
                            {{ nome }}
                        </template>
                        <template #item-documento="{ nome, tipo, cpfcnpj }">
                            <span>{{ cpfcnpj }}</span>
                        </template>

                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <!-- Cadastro de colaboradores -->
            <div class="card">
                <div class="card-header">
                    <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item">
                            <a  class="nav-link active" data-bs-toggle="tab" href="#dadosGerais">Dados colaborador</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#endereco">Endereço</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#cargo">Cargo</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#acesso">Acesso</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#imagens">Imagens</a>
                        </li>

                        
                    </ul>
                </div>
                <div class="card-body tab-content">
                   
                    <div class="tab-pane fade show active" id="dadosGerais">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edid">Código</label>
                                        <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                    </div>
                                </div>
                                <div class="col-lg-10">
                                    <div class="form-group">
                                        <label for="ednome">Nome</label>
                                        <input type="text" v-model="vnome" :disabled="ativadesativa" class="form-control" id="ednome">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edcnpjcpf">CPF</label>
                                        <MaskInput type="text" mask="###.###.###-##" :disabled="ativadesativa"
                                            class="form-control" v-model="vcpfcnpj" id="edcnpjcpf" />
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edpis">PIS/PASEP</label>
                                        <input type="text" v-model="vpispasep" :disabled="ativadesativa" class="form-control" id="edpis">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edrg">Registro geral (RG)</label>
                                        <input type="text" v-model="vrg" :disabled="ativadesativa" class="form-control" id="edrg">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="ednacionalidade">Nacionalidade</label>
                                        <input type="text" v-model="vnacionalidade" :disabled="ativadesativa" class="form-control" id="ednacionalidade">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="ednaturalidade">Naturalidade</label>
                                        <input type="text" v-model="vnaturalidade" :disabled="ativadesativa" class="form-control" id="ednaturalidade">
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="edfone1">Fone 1</label>
                                        <MaskInput type="text" mask="(##) # ####-####" :disabled="ativadesativa"
                                            class="form-control" v-model="vfone1" id="edfone1" />
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="edfone2">Fone 2</label>
                                        <MaskInput type="text" mask="(##) # ####-####" :disabled="ativadesativa"
                                            class="form-control" v-model="vfone2" id="edfone2" />
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="edemail">Email:</label>
                                        <input type="text" v-model="vemail" :disabled="ativadesativa" class="form-control" id="edemail">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="eddatanasc">Data de Nascimento</label>
                                        <input type="date" v-model="dtnascimento" :disabled="ativadesativa" class="form-control" id="eddatanasc">
                                    </div>
                                </div>
                                
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edgenero">Gênero</label>
                                        <select v-model="vgenero" class="form-select" id="edgenero">
                                            <option value="0">Selecione</option>
                                            <option value="1">Masculino</option>
                                            <option value="2">Feminino</option>
                                            <option value="3">Outro</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edestadocivil">Estado Civil</label>
                                        <select v-model="vestadocivil" class="form-select" id="edestadocivil">
                                            <option value="0">Selecione</option>
                                            <option value="1">Solteiro</option>
                                            <option value="2">Casado</option>
                                            <option value="3">Divorciado</option>
                                            <option value="4">Viúvo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <span class="lblselect2">Filial:</span>
                                    <select id="cbempresa" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidempresa">
                                    </select>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="endereco">
                        <div class="container">
                           <div class="row">
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="edcep">*Cep:</label>
                                    <MaskInput type="text" mask="#####-###" v-model="vcep" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edcep" maxlength="9"/>
                                </div>
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <label for="edlogradouro">*Endereço:</label>
                                    <input type="text" v-model="vlogradouro" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edlogradouro" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednrendereco">*Nº Endereço:</label>
                                    <input type="text" v-model="vnrendereco" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="ednrendereco" maxlength="20"
                                        style="text-transform: uppercase;">
                                </div> 
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="edcomplementoend">Complemento:</label>
                                    <input type="text" v-model="vcomplementoend" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edcomplementoend" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="edperimetroend">Perímetro:</label>
                                    <input type="text" v-model="vperimetroend" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edperimetroend" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>                                                        
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="cbbairro">*Bairro:</label>
                                    <select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione uma opção" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label for="cbmunicipio">*Município:</label>
                                    <select id="cbmunicipio" v-model="vidmunicipio"
                                            v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione uma opção" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbuf">*Estado:</label>
                                    <select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione a uf" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>                                            
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="cargo">
                        <div class="container">
                            <div class="row">
                                
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <span class="lblselect2">Subgrupo:</span>
                                    <select id="cbsubgrupo" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidsubgrupo">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <span class="lblselect2">Função:</span>
                                    <select id="cbfuncao" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidfuncao">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <span class="lblselect2">Jornada:</span>
                                    <select id="cbjornada" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidjornada">
                                    </select>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="acesso">
                        <div class="container">
                            <div class="row">
                                <!-- Conteúdo da aba Acesso -->
                                <div class="col-lg-4">
                                    <label for="cbtipoacesso">Ponto por aplicativo</label>
                                    <select class="form-select form-control" v-model="vpontoaplicativo"
                                        aria-label="Default select example">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                    </select>   
                                </div>

                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="eddsenha">Senha</label>
                                        <input type="password" v-model="vsenha" :disabled="ativadesativa" class="form-control" id="eddsenha">
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <span class="lblselect2">Zona/Perimetro:</span>
                                    <select id="cbzona" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidzona">
                                    </select>
                                </div>

                 

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="cbtipoacesso">Ponto por whatsapp</label>
                                        <select class="form-select form-control" v-model="vpontozap">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-4 d-flex align-items-end" v-if="vpontozap == '1'">
                                    <button type="button" @click="mtdabrirmodalZAP()" class="btn btn-success w-100">
                                        <i class="bi bi-whatsapp"></i> Configurar WhatsApp
                                    </button>
                                </div>
                      
                                
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="imagens">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                    <div v-if="lstImagens.length > 0" class="row">
                                        <div v-for="(imagem, index) in lstImagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">
                                            <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgproduto" @click.prevent="mtdexcluirimg(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
                                            <img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">
                                        </div>
                                    </div>
                                    <div v-else class="row">
                                        <div class="col-md-12 text-center">
                                            <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                    <input
                                        type="file"
                                        id="ipselecionarimg"
                                        accept="image/png, image/jpeg"
                                        @change="mtdselecionarimagem"
                                        style="display: none;"
                                        ref="if_imgcolab">
                                    <button type="button" @click="$refs.if_imgcolab.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">
                                <!--// espaço vazio //-->
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-info">
                                    <i class="bi bi-edit"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-warning">
                                    <i class="bi bi-edit"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-danger">
                                    <i class="bi bi-edit"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal de Mapa -->
        <div class="modal fade"  ref="modalzap" tabindex="-1" aria-labelledby="modalzapLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalzapLabel">Configuração</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                      <div class="modal-body">
                        <div class="row mb-4">
                            <div class="col-12">
                                <label class="form-label">Adicionar Novo Número</label>
                                <div class="input-group">
                                    <input type="text" 
                                        v-model="vnovo_numero_zap" 
                                        class="form-control" 
                                        placeholder="Ex: 5511999999999"
                                        @keyup.enter="mtdAdicionarNumeroLista">
                                    <button class="btn btn-info" type="button" @click="mtdAdicionarNumeroLista">
                                        <i class="bi bi-plus-lg"></i>
                                    </button>
                                </div>
                                <small class="text-muted">Pressione Enter ou clique no + para adicionar.</small>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-12">
                                <label class="form-label">Números Configurados</label>
                                <ul class="list-group">
                                    <li v-for="(item, index) in listarzap" :key="index" 
                                        class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>
                                            <i class="bi bi-whatsapp text-success me-2"></i>
                                            {{ item.numero }}
                                        </span>
                                        <button class="btn btn-sm btn-outline-danger" @click="mtdRemoverNumeroLista(index)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </li>
                                    <li v-if="listarzap.length === 0" class="list-group-item text-center text-muted small">
                                        Nenhum número adicionado ainda.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      


    </div>
</template>

<script>
// @ is an alias to /src

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';
import { ref } from "vue";
import MaskInput from '@/components/MaskInput.vue';
import { Modal } from "bootstrap";



const onClickHandler = (page) => {
  console.log(page);
};

const pagina_atual = ref(1);



export default {
    name: 'empresa',

    data() {
        return {
            //variaveis do cadastro 
            opcrud              : 0,
            vid                 : 0,
            vtipo               : 0,
            vnome               : '',
            vcpfcnpj            : '',
            vpispasep           : '',
            vrg                 : '',
            vnacionalidade      : '',
            vnaturalidade       : '',
            vfone1              : '',
            vfone2              : '',
            vemail              : '',
            dtnascimento        : '',
            vgenero             : 0,
            vestadocivil        : 0,
            vidempresa          : null,
            vcep                : '', 
            vlogradouro         : '',
            vnrendereco         : '',
            vcomplementoend     : '',
            vperimetroend       : '',
            vidbairro           : null, 
            vidmunicipio        : null,
            viduf               : null,
            vidgrupo            : null,
            vidsubgrupo         : null,
            vidfuncao           : null,
            vidjornada          : null,
            vidzona             : null,
            vsenha              : '',
            vpontoaplicativo    : '1',
            vpontozap           : '1', 
            vnovo_numero_zap    : '',
        

            arqimgselecionado    : null,
            lstImagens           : [],
            pathimgview          : util.servidor +'/',   





            modulo              : 'COLABORADORES',
            descop              : '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual        : 1,
            pqtdregistros       : 10,
            pqtd_paginas        : 0,



            ModalMenu: null,


            //filtros
            pfiltro             : 1,
            pconteudo           : '',

            ativadesativa       : false,

            headers: [
                { 
                    text    : 'Ações',   
                    value   : 'acoes', 
                    sortable: false, 
                    width: 80 
                },
                { 
                    text    : 'Nome',    
                    value   : 'nome', 
                    sortable: true 
                },
                { 
                    text    : 'CPF', 
                    value   : 'cpfcnpj', 
                    sortable: true 
                },
                { 
                    text    : 'Tipo', 
                    value   : 'tipo', 
                    sortable: true 
                },
            ],
            lstcolaboradores: [],
            listarzap: [],
        }
    },
    components: {
        EasyDataTable,
        MaskInput,
    },
    methods: {
        mtdRemoverNumeroLista(index){
            let vself = this;


            let dados = vself.listarzap[index];

             Swal.fire({
                title: "Confirmação",
                text: 'Confirma exclusão do numero?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                      let parametros = [
                            { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                            { parametro: 'op',            valor: 'deletarnumero' },
                            { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                            { parametro: 'idcolaborador', valor: dados.idcolaborador },
                            { parametro: 'numero',        valor: dados.numero },
                           
                        ];
                        let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
                        retorno.then(function (response) {
                        if ($.isNumeric(response.data)) {
                                util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                            
                                vself.mtdlistarnumeros();
                                
                            } else {
                                let tpret = response.data.substring(0, 1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif('error', 'Informação!', response.data.substring(4));
                                        break;
                                    case 'E': default:
                                        util.notif('error', 'Informação!', response.data.substring(4));
                                        break;
                                }
                            }
                        }).catch(function (response) {
                            alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
                        });
                    
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdAdicionarNumeroLista(){
            let vself = this;
                     
            let parametros = [
                { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',            valor: 'cadastranumero' },
                { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                { parametro: 'idcolaborador', valor: vself.vid },
                { parametro: 'numero',        valor: vself.vnovo_numero_zap },
                { parametro: 'servidor',      valor: util.servidor },
          
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
             if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                   
                    vself.mtdlistarnumeros();
                    vself.vnovo_numero_zap = '';
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });

        },
        mtdlistarnumeros(){
            let vself = this;
         
            let parametros = [
                { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',            valor: 'listarzap' },
                { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                { parametro: 'idcolaborador', valor: vself.vid },
                { parametro: 'servidor',      valor: util.servidor },
          
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.listarzap = response.data;

            }).catch(function (response) {
               
            });
        },
        async mtdabrirmodalZAP(){


            await this.mtdlistarnumeros();


            this.ModalMenu = new Modal(this.$refs.modalzap);

            // 1. Abre o modal do Bootstrap
            this.ModalMenu.show();

        },
        mtdexcluirimg(patharquivo){
            let vself = this;
            let loader       = vself.$loading.show();
            let localarquivo = 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa +'/'+ vself.vpathimagens;

            let parametros      = [
            {parametro: 'op',               valor  : "excluirarquivo"},
            {parametro: 'patharquivo',      valor  : patharquivo},
            {parametro: 'idempresa',        valor  : vself.$store.state.usuario.idempresa },
            {parametro: 'localarquivo',     valor  : localarquivo}

            ];
            let retorno     = util.reqaxios(parametros, 'post',  util.servidor+'/controller/utilitario.php');
            retorno.then(function (response) {
            if ($.isNumeric(response.data.inf)){
                util.notif('success', 'Informação!', 'Imagem excluída com sucesso!');
                vself.lstImagens = [];
                vself.lstImagens = vself.mtdordenaimagens(response.data.arquivos);
            }else{
                util.notif('error', 'Erro!', 'Descrição do erro: '+response.data);
            }
                vself.$loading.hide();
            }).catch(function (response) {
                vself.$loading.hide();
                util.notif('error', 'Erro!', 'Descrição do erro: '+response.message);
            });
        },
        mtdordenaimagens(lstimagens){
                let lstordenada = lstimagens.sort((a, b) => {
                    if (a.arquivo < b.arquivo) {
                        return -1;
                    }
                    if (a.arquivo > b.arquivo) {
                        return 1;
                    }
                    return 0;
                });
                return lstordenada;
        },
        mtdselecionarimagem(event){
            let vself = this;
            vself.$loading.show();
            vself.arqimgselecionado = event.target.files[0];
            let localsalvar = 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa +'/'+ vself.vpathimagens;
            let extarquivo  = vself.arqimgselecionado.name.split('.').pop()
            let nomearquivo = '1.' + extarquivo;
            if(vself.lstImagens.length > 0){
                nomearquivo = (parseInt(vself.lstImagens.pop().arquivo.split('.')[0]) + 1) + '.' + extarquivo;
            }

            let parametros      = [
                {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                {parametro: 'localsalvar',      valor  : localsalvar},
                {parametro: 'nomearquivo',      valor  : nomearquivo},
            ];
            let retorno     = util.reqaxios(parametros, 'post',  util.servidor + '/controller/uploadfile.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data.inf)){
                  
                    vself.lstImagens = [];
                    vself.lstImagens = vself.mtdordenaimagens(response.data.arquivos);
                    console.log(vself.lstImagens);
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimg').val('');
                    vself.$loading.hide();

                }else{
                   vself.$loading.hide();
                }
              
            }).catch(function (response) {
               vself.$loading.hide();
            });

        },
        mtdpesquisacep(){
            let vself = this;
            let cepinf = vself.vcep;
            if ( cepinf != ''){
                if (util.IsCEP(cepinf, '')){
                    vself.$loading.show();
                    let parametros = [
                        {parametro: 'param1', 		valor  : 'consultarcep'},
                        {parametro: 'idempresa',    valor  : vself.$store.state.usuario.idempresa },
                        {parametro: 'cep', 			valor  : cepinf}
                    ];
                    let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/buscarcep.php');
                    retorno.then(function (response) {
                         vself.$loading.hide();
                        if (response.data != '0') {
                            var defmun            = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                            $('#cbmunicipio').append(defmun).trigger('change');

                            var defbai            = new Option(response.data.descbairro, response.data.idbairro, true, true);
                            $('#cbbairro').append(defbai).trigger('change');

                            var defuf             = new Option(response.data.descuf, response.data.iduf, true, true);
                            $('#cbuf').append(defuf).trigger('change');

                            vself.vlogradouro     = response.data.logradouro;
                            vself.vreferencia     = response.data.complemento;
                        }else{
                            vself.$toastr.w('CEP inválido ou inexistente!', 'Atenção!');
                        }					

                    }).catch(function (response) {
                        vself.$loading.hide();
                        console.log(response.message);
                    });
                }
            }                
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : ' and c.id=' + this.pconteudo;
            } else {
                rfiltro = this.pconteudo === '' ? '' : ' and c.upper(nome) like upper("' + this.pconteudo + '%")';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',        valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself  = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioimagens',  valor: 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: vself.pqtdregistros },
                { parametro: 'offset',    valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.lstcolaboradores = JSON.parse(JSON.stringify(response.data));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstcolaboradores = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
        },
        resetarDados() {
            this.vid                = '';
            this.vnome              = '';
            this.vcpfcnpj           = '';
            this.vtipo              = 0;
            this.vpispasep          = '';
            this.vrg                = '';
            this.dtnascimento       = '';
            this.vgenero            = 0;
            this.vestadocivil       = 0;
            this.vnacionalidade     = '';
            this.vnaturalidade      = '';
            this.vfone1             = '';
            this.vfone2             = '';
            this.vemail             = '';
            this.vcep               = '';
            this.vlogradouro        = '';
            this.vnrendereco        = '';
            this.vcomplementoend    = '';
            this.vperimetroend      = '';
            this.vidempresa         = null;
            this.viduf              = null;
            this.vidbairro          = null;
            this.vidmunicipio       = null;
            this.vidgrupo           = null;
            this.vidsubgrupo        = null;
            this.vidfuncao          = null;
            this.vidjornada         = null;
            this.vidzona            = null;
            this.vpontoaplicativo   = 0;
            this.vsenha             = '';

            this.vpathimagens       = '';

            $('#cbempresa').val(null).trigger('change');
            $('#cbuf').val(null).trigger('change');
            $('#cbbairro').val(null).trigger('change');
            $('#cbmunicipio').val(null).trigger('change');
            $('#cbgrupo').val(null).trigger('change');
            $('#cbsubgrupo').val(null).trigger('change');
            $('#cbfuncao').val(null).trigger('change');
            $('#cbjornada').val(null).trigger('change');
            $('#cbzona').val(null).trigger('change');

            
        
        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {
            this.descop = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);
            this.vpathimagens = util.GerarStringAleatoria();
        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();
        },
        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                    vself.mtdregistro();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = ' and c.id=' + id;
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario',         valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa',         valor: vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioimagens',  valor: 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',            valor: filtro },
                { parametro: 'limit',             valor: 1 },
                { parametro: 'offset',            valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {
            this.descop = 'ALTERAÇÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);
        },
        mtdexcluir(id) {
            this.descop = 'EXCLUSÃO'
            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);
        },
        mtdigualarcampos(registro) {
            console.log(registro);
            this.vid                = registro.id;
            this.vnome              = registro.nome;
            this.vtipo              = registro.tipo;
            this.vcpfcnpj           = registro.cpfcnpj;
            this.vpispasep          = registro.pispasep;
            this.vrg                = registro.rg;
            this.dtnascimento       = registro.dtnascimento;
            this.vgenero            = registro.genero;
            this.vestadocivil       = registro.estadocivil;
            this.vnacionalidade     = registro.nacionalidade;
            this.vnaturalidade      = registro.naturalidade;
            this.vfone1             = registro.fone1;
            this.vfone2             = registro.fone2;
            this.vemail             = registro.email;
            this.vcep               = registro.cep;
            this.vlogradouro        = registro.logradouro;
            this.vnrendereco        = registro.numero;
            this.vcomplementoend    = registro.complemento;
            this.vperimetroend      = registro.perimetroend;
            this.vpontoaplicativo   = registro.pontoaplicativo;
            this.vsenha             = registro.senha;

            this.vpathimagens       = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();


            this.lstImagens              = this.mtdordenaimagens(registro.imagens);

            // Empresa
            this.vidempresa = registro.idfilialpadrao;
            let deffilial   = new Option(registro.nomefilial, registro.idfilialpadrao, true, true);
            $('#cbempresa').append(deffilial).trigger('change');

            // UF
            this.viduf = registro.iduf;
            let defuf   = new Option(registro.descuf, registro.iduf, true, true);
            $('#cbuf').append(defuf).trigger('change');

            // Bairro
            this.vidbairro = registro.idbairro;
            let defbairro   = new Option(registro.descbairro, registro.idbairro, true, true);
            $('#cbbairro').append(defbairro).trigger('change');

            // Município
            this.vidmunicipio = registro.idmunicipio;
            let defmunicipio   = new Option(registro.descmunicipio, registro.idmunicipio, true, true);
            $('#cbmunicipio').append(defmunicipio).trigger('change');

            // Grupo
            this.vidgrupo = registro.idgrupo;
            let defgrupo = new Option(registro.nomegrupo, registro.idgrupo, true, true);
            $('#cbgrupo').append(defgrupo).trigger('change');

            // Subgrupo
            this.vidsubgrupo = registro.idsubgrupo;
            let defsubgrupo = new Option(registro.nomesubgrupo, registro.idsubgrupo, true, true);
            $('#cbsubgrupo').append(defsubgrupo).trigger('change');

            // Função
            this.vidfuncao = registro.idfuncao;
            let deffuncao = new Option(registro.nomefuncao, registro.idfuncao, true, true);
            $('#cbfuncao').append(deffuncao).trigger('change');

            // Jornada
            this.vidjornada = registro.idjornada;
            let defjornada = new Option(registro.nomejornada, registro.idjornada, true, true);
            $('#cbjornada').append(defjornada).trigger('change');

        
        },
        mtdregistro() {
            let vself = this;
            let registrocrud = {
                'id'              : this.vid,
                'nome'            : this.vnome,
                'cpfcnpj'         : this.vcpfcnpj.replace(/\D/g, ""),
                'tipo'            : this.vtipo, 
                'pispasep'        : this.vpispasep,
                'rg'              : this.vrg,
                'nacionalidade'   : this.vnacionalidade,
                'naturalidade'    : this.vnaturalidade,
                'fone1'           : this.vfone1,
                'fone2'           : this.vfone2,
                'email'           : this.vemail,
                'dtnascimento'    : this.dtnascimento,
                'genero'          : this.vgenero,
                'estadocivil'     : this.vestadocivil,
                'idempresa'       : this.vidempresa,
                'cep'             : this.vcep,
                'logradouro'      : this.vlogradouro,
                'nrendereco'      : this.vnrendereco,
                'complementoend'  : this.vcomplementoend,
                'perimetroend'    : this.vperimetroend,
                'idbairro'        : this.vidbairro,
                'idmunicipio'     : this.vidmunicipio,
                'iduf'            : this.viduf,
                'idgrupo'         : this.vidgrupo,
                'idsubgrupo'      : this.vidsubgrupo,
                'idfuncao'        : this.vidfuncao,
                'idjornada'       : this.vidjornada,
                'pathimagens'     : this.vpathimagens,
                'senha'           : this.vsenha,
                'pontoaplicativo' : this.vpontoaplicativo,

            };
            let parametros = [
                { parametro: 'op',        valor: 'rotinacrud' },
                { parametro: 'opcrud',    valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro',  valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },
    },
    computed:{
        validou(){
            return this.vnome == '' || this.vcpfcnpj == '' || this.vidjornada == null || this.vrg == '' || this.vnacionalidade ==  '' ||
            this.vnaturalidade == '' || this.vfone1 == '' || this.vemail == '' || this.dtnascimento == '' || this.vidempresa == null || 
            this.vcep == ''

                   
        }
    },
    mounted() {
        let vself = this;
        $loading.show()
        setTimeout(() => {
            this.$loading.hide()
            this.mtdexecutapesquisa();
        }, 1000)
        $('#pncadastro').hide();

        $("#edcep").blur(function(){
            vself.mtdpesquisacep();
        });

           //selects da consulta
        $("#cbempresa").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfiliais ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidempresa = $("#cbempresa").val();
        });

        $("#cbgrupo").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbgrupos ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidgrupo = $("#cbgrupo").val();
        });

        
        $("#cbsubgrupo").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbsubgrupos ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidsubgrupo = $("#cbsubgrupo").val();
        });

        
        $("#cbfuncao").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfuncoes ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidfuncao = $("#cbfuncao").val();
        });

        
        $("#cbfuncao").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfuncoes ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidfuncao = $("#cbfuncao").val();
        });


          
        $("#cbmunicipio").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbmunicipios ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidmunicipio = $("#cbmunicipio").val();
        });


        $("#cbbairro").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbbairros ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidbairro = $("#cbbairro").val();
        });


        $("#cbuf").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbufs ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.viduf = $("#cbuf").val();
        });

        $("#cbjornada").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbjornadas ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap', 
            language: "pt-BR",
            templateResult: util.formatResult,  
            templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidjornada = $("#cbjornada").val();
                });

        $("#cbzona").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbzonas ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap', 
            language: "pt-BR",
            templateResult: util.formatResult,  
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidzona = $("#cbzona").val();
        });        

    },
    watch:{
        pagina_atual(val){
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>

.pagination-container {
    display: flex;

    column-gap: 10px;
  }

  .paginate-buttons {
  

    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #13534a;

    border: 1px solid #13534a;

    color: white;
  }

  .active-page:hover {
    background-color: #13534a;
  }

</style>